window.Application =
  lang: ->
    @_lang ||= $('html').attr('lang') || 'de'

  isProduction:   process.env.NODE_ENV == "production"
  isDevelopment:  process.env.NODE_ENV == "development"
  isTest:         process.env.NODE_ENV == "test"
